var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-wrapper"},[_c('svg',{staticClass:"ring",attrs:{"viewBox":"0 0 40 40"}},[_c('circle',{attrs:{"fill":"transparent","r":"18","cx":"20","cy":"20"}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }